import { create } from 'zustand';
import { useDeviceStore } from './deviceStore';

interface ContactAnalysisState {
  startFrame: number | null;
  endFrame: number | null;
  fps: number;
  analysisType: 'contact' | 'flight' | null;
  contactTime: number | null;
  flightTime: number | null;
  results: { type: 'contact' | 'flight'; time: number }[];
  setStartFrame: (frame: number) => void;
  setEndFrame: (frame: number) => void;
  setFps: (fps: number) => void;
  setAnalysisType: (type: 'contact' | 'flight' | null) => void;
  calculateAndSetTime: () => void;
  reset: () => void;
}

export const useContactAnalysisStore = create<ContactAnalysisState>((set, get) => ({
  startFrame: null,
  endFrame: null,
  fps: 240,
  analysisType: null,
  contactTime: null,
  flightTime: null,
  results: [],
  setStartFrame: (frame) => set({ startFrame: frame }),
  setEndFrame: (frame) => set({ endFrame: frame }),
  setFps: (fps) => set({ fps }),
  setAnalysisType: (type) => set({ analysisType: type }),
  calculateAndSetTime: () => {
    const { startFrame, endFrame, fps, analysisType } = get();
    if (startFrame === null || endFrame === null || !analysisType) return;

    const deviceType = useDeviceStore.getState().deviceType;
    
    // iPhoneの場合は4で割って補正、PCの場合はそのまま
    let frameCount = Math.abs(endFrame - startFrame) / (deviceType === 'iphone' ? 4 : 1);
    
    // 120fpsと240fpsの場合はフレーム数を半分にする
    if (fps >= 120) {
      frameCount = frameCount / 2;
    }
    
    // 新しい計算式：時間 = フレーム数/fps
    const time = frameCount / fps;

    if (analysisType === 'contact') {
      set(state => ({ 
        contactTime: time,
        results: [...state.results, { type: 'contact', time }]
      }));
    } else {
      set(state => ({ 
        flightTime: time,
        results: [...state.results, { type: 'flight', time }]
      }));
    }
  },
  reset: () => set({ 
    startFrame: null, 
    endFrame: null, 
    analysisType: null 
  }),
}));